module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_China-Beijing.1fa62a7b.jpg";